import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import style from './Home.module.css';
import Header from './common/Header';
import withTracker from '../withTracker';

class Home extends Component {
  render() {
    return (
      <main className={style.content}>
        <div className={style.bg}></div>
        <Header noHeader={true} title='トップ' />
        <section className={style.hero}>
          <div className={style.section_content}>
            <h1>第60回 柏苑祭</h1>
            <h2>~ Adventure ~</h2>
          </div>
          <div className={style.scroll_down}>
            <p>↓</p>
          </div>
        </section>

        <section className={style.date}>
          <div className={style.section_content}>
            <h2>開催日時</h2>
            <h3>9月 29日(土)</h3>
            <p>9:00 ~ 16:00</p>
            <h3>9月 30日(日)</h3>
            <p>9:00 ~ 17:30</p>
            <p>(展示は15:30まで)</p>
          </div>
        </section>

        <section className={style.intro}>
          <div className={style.section_content}>
            <h2>Menu</h2>
            <div className={style.category}>
              <div className={style.category_line}>
                <Link className={style.exhibition} to="/category/exhibition.html">展示</Link>
                <Link className={style.food} to="/category/store.html">模擬店</Link>
              </div>
              <div className={style.category_line}>
                <Link className={style.event} to="/category/event.html">イベント</Link>
                <Link className={style.stage} to="/category/stage.html">舞台</Link>
              </div>
              <div className={style.category_line}>
                <Link className={style.after_fes} to="/category/after-fes.html">宴夜祭</Link>
              </div>
            </div>
            {
            /*
            <div style={{ padding: 15 }}>
              <a href='http://' className={style.quest}>
                <p>柏苑祭アンケートに答えて</p>
                <p>としまろ壁紙をゲット！</p>
              </a>
            </div>
            */
            }
          </div>
        </section>
      </main>
    );
  }
}

export default withTracker(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js